import { render } from "./Supervisor.vue?vue&type=template&id=868dbef0&scoped=true"
import script from "./Supervisor.vue?vue&type=script&lang=js"
export * from "./Supervisor.vue?vue&type=script&lang=js"

import "./Supervisor.vue?vue&type=style&index=0&id=868dbef0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868dbef0"]])

export default __exports__